import React from "react";
import PropTypes from "prop-types";
import {getDataAttributes} from "./Component";

const Tag = (props) => {
    const {
        label,
        tooltip,
        icon,
        disabled,
        onClick,       // legacy: treat as "icon click" if no onIconClick provided
        onTagClick,
        onIconClick,
        clickTarget = "icon", // 'icon' | 'tag' | 'both'
        className,
        color,
        size,
        isLight,
        isOutlined,
        isRounded,
        ...rest
    } = props;

    const clickableTag = clickTarget === "tag" || clickTarget === "both";
    const clickableIcon = !!icon && !disabled && (clickTarget === "icon" || clickTarget === "both");

    const _className = () =>
        (className ? " " + className : "") +
        (color ? " is-" + color : "") +
        (size ? " is-" + size : "") +
        (isLight ? " is-light" : "") +
        (!!tooltip ? " has-tooltip" : "") +
        (isOutlined ? " is-outlined" : "") +
        (isRounded ? " is-rounded" : "");

    const handleTagActivate = (e) => {
        if (disabled || !clickableTag) return;
        // Prefer explicit handler; fall back to icon handler; then legacy onClick
        (onTagClick || onIconClick || onClick)?.(e);
    };

    const handleIconActivate = (e) => {
        if (!clickableIcon) return;
        e.preventDefault();
        (onIconClick || onClick)?.(e);
    };

    const handleTagKeyDown = (e) => {
        if (!clickableTag) return;
        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            handleTagActivate(e);
        }
    };

    return (
        <span
            className={"tag " + _className()}
            data-tooltip={tooltip}
            {...getDataAttributes(props)}
            {...rest}
            // Make the *whole tag* focusable/clickable if allowed
            role={clickableTag ? "button" : undefined}
            tabIndex={clickableTag ? 0 : undefined}
            aria-disabled={disabled ? "true" : undefined}
            onClick={clickableTag ? handleTagActivate : undefined}
            onKeyDown={clickableTag ? handleTagKeyDown : undefined}
            style={{
                cursor: clickableTag ? "pointer" : "default",
                ...rest.style
            }}
        >
      <>
        {label}
          {icon && (
              <>
                  &nbsp;
                  <span
                      className={"icon solid " + icon}
                      role={clickableIcon ? "button" : undefined}
                      aria-label={clickableIcon ? "toggle" : undefined}
                      tabIndex={clickableIcon ? 0 : undefined}
                      onClick={handleIconActivate}
                      onKeyDown={(e) => {
                          if (!clickableIcon) return;
                          if (e.key === "Enter" || e.key === " ") {
                              e.preventDefault();
                              handleIconActivate(e);
                          }
                      }}
                      style={{cursor: clickableIcon ? "pointer" : "default"}}
                  />
              </>
          )}
      </>
    </span>
    );
};

Tag.propTypes = {
    label: PropTypes.string,
    tooltip: PropTypes.string,
    icon: PropTypes.string,
    onClick: PropTypes.func,     // legacy (treated as icon click if onIconClick not provided)
    onTagClick: PropTypes.func,  // click on tag area
    onIconClick: PropTypes.func, // click on icon area
    clickTarget: PropTypes.oneOf(["icon", "tag", "both"]),
    onClose: PropTypes.func,
    color: PropTypes.oneOf([
        "primary","secondary","link","info","success","warning","danger",
        "white","light","dark","black","text","default",
        "tag-green","tag-yellow","tag-orange","tag-blue","tag-purple","tag-blue-neon"
    ]),
    isLight: PropTypes.bool,
    isRounded: PropTypes.bool,
    disabled: PropTypes.bool,
    size: PropTypes.oneOf(["small", "normal", "medium", "large"]),
    className: PropTypes.string,
};

export default Tag;


// import React from "react";
// import PropTypes from "prop-types";
// import {getDataAttributes} from "./Component";
//
// const Tag = (props) => {
//
//     const _className = () => {
//         // console.log(props.tooltip);
//         return (props.className ? " " + props.className : "")
//             + (props.color ? " is-" + props.color : "")
//             + (props.size ? " is-" + props.size : "")
//             + (props.isLight ? " is-light" : "")
//             + (!!props.tooltip ? " has-tooltip" : "")
//             + (props.isOutlined ? " is-outlined" : "")
//             + (props.isRounded ? " is-rounded" : "");
//     }
//
//     return (
//         <span className={"tag " + _className()} data-tooltip={props.tooltip}
//               {...getDataAttributes(props)}>
//         <>
//             {props.label}
//             &nbsp;
//             {props.icon && !props.disabled &&
//                 <span style={{cursor: props.onClick ? "pointer" : "default"}}
//                       className={"icon solid " + props.icon}
//                       onClick={e => {
//                           e.preventDefault();
//                           props.onClick(e);
//                       }}
//                       role="button">
//                 </span>
//             }
//         </>
//
//        </span>
//     )
// }
//
// Tag.propTypes = {
//     label: PropTypes.string,
//     tooltip: PropTypes.string,
//     icon: PropTypes.string,
//     onClick: PropTypes.func,
//     onClose: PropTypes.func,
//     color: PropTypes.oneOf(["primary", "secondary", "link", "info", "success", "warning", "danger", "white", "light", "dark", "black", "text", "default", "tag-green", "tag-yellow", "tag-orange", "tag-blue", "tag-purple", "tag-blue-neon"]),
//     isLight: PropTypes.bool,
//     isRounded: PropTypes.bool,
//     disabled: PropTypes.bool,
//     size: PropTypes.oneOf(["small", "normal", "medium", "large"]),
//     className: PropTypes.string,
// };
//
// export default Tag;
